module.exports = __webpack_public_path__ + "img/vtg-qr-code.a6ed7c60.png";